import { render } from "./Workflow.vue?vue&type=template&id=0c64a119&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"

import "./Workflow.vue?vue&type=style&index=0&id=0c64a119&scoped=true&lang=css"
import "./Workflow.vue?vue&type=style&index=1&id=0c64a119&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c64a119"]])

export default __exports__